module.exports = __webpack_public_path__ + "static/media/ivancik.8799a9d6.jpg";